module.exports = __webpack_public_path__ + "static/brin_sprite.28489cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brin_sprite.png
// module id = 151
// module chunks = 35783957827783 195814232070997 206603627034982